import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import cacheService from './services/cacheService';
import '@fortawesome/fontawesome-free/css/all.css';

axios.defaults.withCredentials = true;

// Make axios available globally
Vue.prototype.$http = axios;

// Make cache service available globally
Vue.prototype.$cache = cacheService;

Vue.config.productionTip = false;

// Make Vue accessible globally for the token service
window.Vue = Vue;

// Add global methods for notifications
Vue.prototype.$toast = function(options) {
  this.$root.$emit('show-toast', options);
};

// Create Vue instance
const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
